import style from '../portfolio-items.module.css'
import Carousel from './embla-carousel/ageu-embla.jsx'
import Portfolio from '../../../main/portfolio.jsx'
import ContactForm from '../../../main/contactForm.jsx'
import HireUs from '../../../forIndustrial/hireUs.jsx'

const OPTIONS = {}

export default function Ageu(props) {
    return (
        <div className={style.wrapper}>
            <div className={style.container}>
                <h1><span style={{color: '#ff8c00'}}>Автономная гибридная энергоустановка</span><br /> для АО "Россети Научно-технический центр"</h1>
                <Carousel options={OPTIONS} />
                <div className={style.description}>
                    <div className={style.tasks}>
                        <h6>Задача:</h6>
                        <p>Обеспечить автономное электроснабжение удалённого потребителя</p>
                    </div>
                    <div className={style.specification}>
                        <div сlassName={style.info}>
                            <p><strong>Заказчик: </strong>ООО «Юнигрин Инжиниринг» (ГК «Хевел»).</p>
                            <p><strong>Конечный заказчик: </strong>АО «Россети Научно-технический центр».</p>
                            <p><strong>Дата: </strong>ноябрь - декабрь 2024 г.</p>
                            <p><strong>Срок выполнения: </strong>15 рабочих дней.</p>
                            <h3 className={style.results}>Результаты работ:</h3>
                            <ul>
                                <li>Обеспечено автономное электроснабжение удалённого потребителя без подключения к внешним сетям.</li>
                                <li>Комбинированная система (дизель-генератор + ветрогенератор + солнечные панели) гарантирует бесперебойную работу в любых погодных условиях.</li>
                                <li>Заказчик получил готовое решение «под ключ»: от фундаментов до ограждения.</li>
                            </ul>
                        </div>
                        <div className={style.solution}>
                            <h3>Решения для проекта:</h3>
                            <ul>
                                <li>Выполнена подготовка основания под контейнер и под опорные конструкции ФЭС: удаление плодородного слоя (200 мм), укладка геотекстиля, щебня фр. 5-20, монтаж дорожных плит.</li>
                                <li>Установлен контейнер АГЭУ с креплением к плите химическими анкерами.</li>
                                <li>Смонтирована мачта и установлена ВЭУ.</li>
                                <li>Смонтирована фотоэлектрическая система (ФЭС) на опорной металлической конструкции.</li>
                                <li>Произведены пусконаладочные работы и настройка гибридной системы (дизель-генератор + ВЭУ + ФЭС).</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <HireUs />
            <Portfolio />
            <div style={{height: '2rem'}}></div>
            <ContactForm />
        </div>
    )
}